import {Organization} from "@models/organization.model.ts";

export class Launch {
  id: number;
  name: string;
  engagement_id?: number;
  type?: string;
  objective_id?: number;
  population_segment_id?: number | null;
  // True when a user actively chose "no population" (lookalike / DB-fed),
  // as opposed to the choice never having been made.
  population_segment_explicit_none: boolean;
  schedule_entry_id?: number;
  // "Campaign Start Date" (MPN-1578): when this campaign actually first published, as
  // stamped by MPN-1498. Read-only — there is no user-editable path on the server.
  go_live_date?: string | null;
  /** The campaign's own dates (MPN-2040). Null until someone sets them — 114 of the 200
   *  campaigns in production have none. */
  campaign_start?: string | null;
  campaign_end?: string | null;
  organizations: Organization[];

  constructor() {
    this.id = -1;
    this.name = "";
    this.engagement_id = undefined;
    this.type = undefined;
    this.objective_id = undefined;
    this.population_segment_id = undefined;
    this.population_segment_explicit_none = false;
    this.schedule_entry_id = undefined;
    this.go_live_date = null;
    this.organizations = [];
  }
}